// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =======================
   Blog Page Styling
======================= */

.blog-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  background: #f8f9fa;
  min-height: 100vh;
}

/* ===== Header ===== */
.blog-header {
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem 0;
}

.blog-title {
  color: #00703C;
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.blog-subtitle {
  color: #666;
  margin-bottom: 0;
  font-size: 1.1rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}

/* ===== Controls Section ===== */
.blog-controls {
  margin-bottom: 3rem;
}

/* ===== Search Bar ===== */
.search-wrapper {
  max-width: 600px;
  margin: 0 auto 2rem;
}

.search-bar {
  width: 100%;
  padding: 0.9rem 1.5rem;
  border-radius: 50px;
  border: 2px solid #e0e0e0;
  outline: none;
  transition: all 0.3s ease;
  font-size: 1rem;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.search-bar:focus {
  border-color: #00703C;
  box-shadow: 0 4px 12px rgba(0, 112, 60, 0.15);
}

/* ===== Category Filter ===== */
.category-filter {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem;
  padding: 0 1rem;
}

.category-btn {
  padding: 0.6rem 1.5rem;
  border-radius: 25px;
  border: 2px solid #e0e0e0;
  background: #fff;
  color: #555;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
}

.category-btn:hover {
  border-color: #00703C;
  color: #00703C;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 112, 60, 0.1);
}

.category-btn.active {
  background: #00703C;
  color: white;
  border-color: #00703C;
  box-shadow: 0 4px 12px rgba(0, 112, 60, 0.2);
}

/* ===== Loading ===== */
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 1rem;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #00703C;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.small-spinner {
  width: 20px;
  height: 20px;
  border: 3px solid #fff;
  border-top: 3px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ===== Posts Grid ===== */
.posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 2rem;
  align-items: start;
  margin-bottom: 3rem;
}

/* ===== Post Card ===== */
.post-card {
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.post-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 112, 60, 0.15);
}

/* ===== Gallery ===== */
.post-gallery {
  position: relative;
  background: #f5f5f5;
  width: 100%;
}

.gallery-grid {
  display: grid;
  gap: 2px;
  background: #fff;
  width: 100%;
}

.gallery-grid.single {
  grid-template-columns: 1fr;
}

.gallery-grid.single .gallery-item {
  height: 280px;
}

.gallery-grid.double {
  grid-template-columns: 1fr 1fr;
}

.gallery-grid.double .gallery-item {
  height: 200px;
}

.gallery-grid.multiple {
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 150px;
}

.gallery-item {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  background: #f0f0f0;
  width: 100%;
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  display: block;
}

.gallery-item:hover img {
  transform: scale(1.05);
}

.more-images-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2rem;
  font-weight: 700;
}

.gallery-indicator {
  position: absolute;
  bottom: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 6px;
  backdrop-filter: blur(8px);
  z-index: 1;
}

/* ===== Post Content ===== */
.post-content {
  padding: 1.5rem;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.post-category {
  display: inline-block;
  background: #00703C;
  color: white;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1rem;
  align-self: flex-start;
}

.post-title {
  color: #1a1a1a;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  line-height: 1.3;
}

.post-description-wrapper {
  margin-bottom: 1.5rem;
  flex: 1 1;
}

.post-description {
  color: #555;
  font-size: 0.95rem;
  line-height: 1.7;
  margin-bottom: 0.5rem;
}

.read-more-btn {
  background: none;
  border: none;
  color: #00703C;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s ease;
  text-decoration: underline;
}

.read-more-btn:hover {
  color: #005a30;
}

.post-video {
  width: 100%;
  max-height: 300px;
  border-radius: 12px;
  background-color: #000;
  margin-bottom: 1rem;
  object-fit: contain;
}

.post-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  border-top: 1px solid #eee;
  margin-top: auto;
}

.post-meta time {
  color: #999;
  font-size: 0.85rem;
  font-weight: 500;
}

/* ===== Share Button & Dropdown ===== */
.post-actions {
  position: relative;
}

.share-dropdown {
  position: relative;
}

.share-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: #fff;
  color: #555;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
}

.share-btn:hover {
  background: #f8f9fa;
  border-color: #00703C;
  color: #00703C;
}

.share-btn svg {
  stroke-width: 2;
}

.share-menu {
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-bottom: 0.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 0.5rem;
  min-width: 180px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
  z-index: 10;
}

.share-dropdown:hover .share-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.share-menu button {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0.7rem 1rem;
  border: none;
  background: none;
  color: #333;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
  text-align: left;
}

.share-menu button:hover {
  background: #f8f9fa;
  color: #00703C;
}

.share-menu button svg {
  flex-shrink: 0;
}

/* ===== Load More Button ===== */
.load-more-wrapper {
  display: flex;
  justify-content: center;
  margin: 3rem 0;
}

.load-more-btn {
  padding: 1rem 2.5rem;
  background: #00703C;
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 112, 60, 0.2);
  display: flex;
  align-items: center;
  gap: 10px;
}

.load-more-btn:hover:not(:disabled) {
  background: #005a30;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 112, 60, 0.3);
}

.load-more-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* ===== Modal ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  animation: fadeIn 0.3s ease;
  overflow-y: auto;
}

.modal-content {
  background: white;
  border-radius: 20px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  padding: 2.5rem;
  position: relative;
  animation: slideUp 0.3s ease;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-close {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: #f0f0f0;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 1;
}

.modal-close:hover {
  background: #e0e0e0;
  transform: rotate(90deg);
}

.modal-category {
  display: inline-block;
  background: #00703C;
  color: white;
  padding: 0.5rem 1.2rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1.5rem;
}

.modal-title {
  color: #1a1a1a;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.3;
  padding-right: 3rem;
}

.modal-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.modal-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.modal-image:hover {
  transform: scale(1.05);
}

.modal-description {
  color: #444;
  font-size: 1.05rem;
  line-height: 1.8;
  margin-bottom: 2rem;
  white-space: pre-wrap;
}

.modal-video {
  width: 100%;
  max-height: 400px;
  border-radius: 12px;
  background-color: #000;
  margin-bottom: 2rem;
}

.modal-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #00703C;
  font-weight: 600;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 10px;
  background: #f0f9f4;
  font-size: 1rem;
  transition: all 0.2s ease;
  margin-bottom: 2rem;
}

.modal-link:hover {
  background: #00703C;
  color: white;
}

.modal-footer {
  padding-top: 1.5rem;
  border-top: 2px solid #f0f0f0;
}

.modal-date {
  color: #999;
  font-size: 0.95rem;
  font-weight: 500;
}

/* ===== Lightbox ===== */
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  animation: fadeIn 0.2s ease;
}

.lightbox-content {
  max-width: 90%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.lightbox-content img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 8px;
}

.lightbox-caption {
  color: white;
  text-align: center;
  font-size: 1rem;
  max-width: 600px;
}

.lightbox-counter {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  font-weight: 500;
}

.lightbox-close,
.lightbox-prev,
.lightbox-next {
  position: fixed;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  cursor: pointer;
  padding: 1rem;
  border-radius: 50%;
  transition: all 0.2s ease;
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.lightbox-close:hover,
.lightbox-prev:hover,
.lightbox-next:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.lightbox-close {
  top: 2rem;
  right: 2rem;
}

.lightbox-prev {
  left: 2rem;
  top: 50%;
  transform: translateY(-50%);
}

.lightbox-prev:hover {
  transform: translateY(-50%) scale(1.1);
}

.lightbox-next {
  right: 2rem;
  top: 50%;
  transform: translateY(-50%);
}

.lightbox-next:hover {
  transform: translateY(-50%) scale(1.1);
}

/* ===== No posts message ===== */
.no-posts {
  text-align: center;
  color: #999;
  font-size: 1.1rem;
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.no-posts svg {
  color: #ddd;
}

/* ===== Responsive Design ===== */
@media (max-width: 1024px) {
  .posts-grid {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  }
}

@media (max-width: 768px) {
  .blog-title {
    font-size: 2rem;
  }

  .blog-subtitle {
    font-size: 1rem;
  }

  .category-filter {
    gap: 0.5rem;
  }

  .category-btn {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
  }

  .posts-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .gallery-grid.single .gallery-item {
    height: 250px;
  }

  .gallery-grid.double .gallery-item {
    height: 180px;
  }

  .gallery-grid.multiple {
    grid-auto-rows: 130px;
  }

  .share-menu {
    right: auto;
    left: 0;
  }

  .modal-content {
    padding: 2rem 1.5rem;
  }

  .modal-title {
    font-size: 1.6rem;
  }

  .modal-gallery {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }

  .modal-image {
    height: 150px;
  }

  .lightbox-prev,
  .lightbox-next {
    padding: 0.75rem;
  }

  .lightbox-close {
    top: 1rem;
    right: 1rem;
  }

  .post-video,
  .modal-video {
    max-height: 250px;
  }
}

@media (max-width: 480px) {
  .blog-container {
    padding: 1rem;
  }

  .blog-header {
    margin-bottom: 1.5rem;
    padding: 1rem 0;
  }

  .blog-controls {
    margin-bottom: 2rem;
  }

  .search-wrapper {
    margin-bottom: 1.5rem;
  }

  .category-filter {
    padding: 0;
  }

  .post-title {
    font-size: 1.3rem;
  }

  .post-footer {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  .gallery-grid.single .gallery-item {
    height: 200px;
  }

  .gallery-grid.double .gallery-item {
    height: 150px;
  }

  .gallery-grid.multiple {
    grid-auto-rows: 120px;
  }

  .modal-overlay {
    padding: 1rem;
  }

  .modal-content {
    padding: 1.5rem 1rem;
    max-height: 95vh;
  }

  .modal-close {
    width: 35px;
    height: 35px;
    top: 1rem;
    right: 1rem;
  }

  .modal-title {
    font-size: 1.4rem;
    padding-right: 2.5rem;
  }

  .modal-gallery {
    grid-template-columns: 1fr;
  }

  .load-more-btn {
    padding: 0.9rem 2rem;
    font-size: 0.95rem;
  }
}

/* ===== Scrollbar Styling ===== */
.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.modal-content::-webkit-scrollbar-thumb {
  background: #00703C;
  border-radius: 10px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: #005a30;
}`, "",{"version":3,"sources":["webpack://./src/pages/Blog.css"],"names":[],"mappings":"AAAA;;yBAEyB;;AAEzB;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,gFAAgF;EAChF,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;EACf,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* =======================\n   Blog Page Styling\n======================= */\n\n.blog-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem 1.5rem;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  background: #f8f9fa;\n  min-height: 100vh;\n}\n\n/* ===== Header ===== */\n.blog-header {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding: 2rem 0;\n}\n\n.blog-title {\n  color: #00703C;\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n}\n\n.blog-subtitle {\n  color: #666;\n  margin-bottom: 0;\n  font-size: 1.1rem;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.6;\n}\n\n/* ===== Controls Section ===== */\n.blog-controls {\n  margin-bottom: 3rem;\n}\n\n/* ===== Search Bar ===== */\n.search-wrapper {\n  max-width: 600px;\n  margin: 0 auto 2rem;\n}\n\n.search-bar {\n  width: 100%;\n  padding: 0.9rem 1.5rem;\n  border-radius: 50px;\n  border: 2px solid #e0e0e0;\n  outline: none;\n  transition: all 0.3s ease;\n  font-size: 1rem;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.search-bar:focus {\n  border-color: #00703C;\n  box-shadow: 0 4px 12px rgba(0, 112, 60, 0.15);\n}\n\n/* ===== Category Filter ===== */\n.category-filter {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 0 1rem;\n}\n\n.category-btn {\n  padding: 0.6rem 1.5rem;\n  border-radius: 25px;\n  border: 2px solid #e0e0e0;\n  background: #fff;\n  color: #555;\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.category-btn:hover {\n  border-color: #00703C;\n  color: #00703C;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 112, 60, 0.1);\n}\n\n.category-btn.active {\n  background: #00703C;\n  color: white;\n  border-color: #00703C;\n  box-shadow: 0 4px 12px rgba(0, 112, 60, 0.2);\n}\n\n/* ===== Loading ===== */\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 1rem;\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #00703C;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.small-spinner {\n  width: 20px;\n  height: 20px;\n  border: 3px solid #fff;\n  border-top: 3px solid transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* ===== Posts Grid ===== */\n.posts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));\n  gap: 2rem;\n  align-items: start;\n  margin-bottom: 3rem;\n}\n\n/* ===== Post Card ===== */\n.post-card {\n  background-color: #fff;\n  border-radius: 16px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.post-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 24px rgba(0, 112, 60, 0.15);\n}\n\n/* ===== Gallery ===== */\n.post-gallery {\n  position: relative;\n  background: #f5f5f5;\n  width: 100%;\n}\n\n.gallery-grid {\n  display: grid;\n  gap: 2px;\n  background: #fff;\n  width: 100%;\n}\n\n.gallery-grid.single {\n  grid-template-columns: 1fr;\n}\n\n.gallery-grid.single .gallery-item {\n  height: 280px;\n}\n\n.gallery-grid.double {\n  grid-template-columns: 1fr 1fr;\n}\n\n.gallery-grid.double .gallery-item {\n  height: 200px;\n}\n\n.gallery-grid.multiple {\n  grid-template-columns: 1fr 1fr;\n  grid-auto-rows: 150px;\n}\n\n.gallery-item {\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  background: #f0f0f0;\n  width: 100%;\n}\n\n.gallery-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n  display: block;\n}\n\n.gallery-item:hover img {\n  transform: scale(1.05);\n}\n\n.more-images-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.gallery-indicator {\n  position: absolute;\n  bottom: 12px;\n  right: 12px;\n  background: rgba(0, 0, 0, 0.75);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  backdrop-filter: blur(8px);\n  z-index: 1;\n}\n\n/* ===== Post Content ===== */\n.post-content {\n  padding: 1.5rem;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.post-category {\n  display: inline-block;\n  background: #00703C;\n  color: white;\n  padding: 0.4rem 1rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 1rem;\n  align-self: flex-start;\n}\n\n.post-title {\n  color: #1a1a1a;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  line-height: 1.3;\n}\n\n.post-description-wrapper {\n  margin-bottom: 1.5rem;\n  flex: 1;\n}\n\n.post-description {\n  color: #555;\n  font-size: 0.95rem;\n  line-height: 1.7;\n  margin-bottom: 0.5rem;\n}\n\n.read-more-btn {\n  background: none;\n  border: none;\n  color: #00703C;\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n  padding: 0;\n  transition: color 0.2s ease;\n  text-decoration: underline;\n}\n\n.read-more-btn:hover {\n  color: #005a30;\n}\n\n.post-video {\n  width: 100%;\n  max-height: 300px;\n  border-radius: 12px;\n  background-color: #000;\n  margin-bottom: 1rem;\n  object-fit: contain;\n}\n\n.post-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 1rem;\n  border-top: 1px solid #eee;\n  margin-top: auto;\n}\n\n.post-meta time {\n  color: #999;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n/* ===== Share Button & Dropdown ===== */\n.post-actions {\n  position: relative;\n}\n\n.share-dropdown {\n  position: relative;\n}\n\n.share-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  background: #fff;\n  color: #555;\n  font-weight: 600;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  outline: none;\n}\n\n.share-btn:hover {\n  background: #f8f9fa;\n  border-color: #00703C;\n  color: #00703C;\n}\n\n.share-btn svg {\n  stroke-width: 2;\n}\n\n.share-menu {\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n  margin-bottom: 0.5rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  padding: 0.5rem;\n  min-width: 180px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(10px);\n  transition: all 0.3s ease;\n  z-index: 10;\n}\n\n.share-dropdown:hover .share-menu {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.share-menu button {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 0.7rem 1rem;\n  border: none;\n  background: none;\n  color: #333;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.share-menu button:hover {\n  background: #f8f9fa;\n  color: #00703C;\n}\n\n.share-menu button svg {\n  flex-shrink: 0;\n}\n\n/* ===== Load More Button ===== */\n.load-more-wrapper {\n  display: flex;\n  justify-content: center;\n  margin: 3rem 0;\n}\n\n.load-more-btn {\n  padding: 1rem 2.5rem;\n  background: #00703C;\n  color: white;\n  border: none;\n  border-radius: 50px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 112, 60, 0.2);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.load-more-btn:hover:not(:disabled) {\n  background: #005a30;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 112, 60, 0.3);\n}\n\n.load-more-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* ===== Modal ===== */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 9998;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  animation: fadeIn 0.3s ease;\n  overflow-y: auto;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 20px;\n  max-width: 800px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  padding: 2.5rem;\n  position: relative;\n  animation: slideUp 0.3s ease;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modal-close {\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  background: #f0f0f0;\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  z-index: 1;\n}\n\n.modal-close:hover {\n  background: #e0e0e0;\n  transform: rotate(90deg);\n}\n\n.modal-category {\n  display: inline-block;\n  background: #00703C;\n  color: white;\n  padding: 0.5rem 1.2rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 1.5rem;\n}\n\n.modal-title {\n  color: #1a1a1a;\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  line-height: 1.3;\n  padding-right: 3rem;\n}\n\n.modal-gallery {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.modal-image {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.modal-image:hover {\n  transform: scale(1.05);\n}\n\n.modal-description {\n  color: #444;\n  font-size: 1.05rem;\n  line-height: 1.8;\n  margin-bottom: 2rem;\n  white-space: pre-wrap;\n}\n\n.modal-video {\n  width: 100%;\n  max-height: 400px;\n  border-radius: 12px;\n  background-color: #000;\n  margin-bottom: 2rem;\n}\n\n.modal-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #00703C;\n  font-weight: 600;\n  text-decoration: none;\n  padding: 12px 20px;\n  border-radius: 10px;\n  background: #f0f9f4;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  margin-bottom: 2rem;\n}\n\n.modal-link:hover {\n  background: #00703C;\n  color: white;\n}\n\n.modal-footer {\n  padding-top: 1.5rem;\n  border-top: 2px solid #f0f0f0;\n}\n\n.modal-date {\n  color: #999;\n  font-size: 0.95rem;\n  font-weight: 500;\n}\n\n/* ===== Lightbox ===== */\n.lightbox {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.95);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  animation: fadeIn 0.2s ease;\n}\n\n.lightbox-content {\n  max-width: 90%;\n  max-height: 90%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.lightbox-content img {\n  max-width: 100%;\n  max-height: 80vh;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.lightbox-caption {\n  color: white;\n  text-align: center;\n  font-size: 1rem;\n  max-width: 600px;\n}\n\n.lightbox-counter {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.lightbox-close,\n.lightbox-prev,\n.lightbox-next {\n  position: fixed;\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: white;\n  cursor: pointer;\n  padding: 1rem;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lightbox-close:hover,\n.lightbox-prev:hover,\n.lightbox-next:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: scale(1.1);\n}\n\n.lightbox-close {\n  top: 2rem;\n  right: 2rem;\n}\n\n.lightbox-prev {\n  left: 2rem;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.lightbox-prev:hover {\n  transform: translateY(-50%) scale(1.1);\n}\n\n.lightbox-next {\n  right: 2rem;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.lightbox-next:hover {\n  transform: translateY(-50%) scale(1.1);\n}\n\n/* ===== No posts message ===== */\n.no-posts {\n  text-align: center;\n  color: #999;\n  font-size: 1.1rem;\n  padding: 4rem 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.no-posts svg {\n  color: #ddd;\n}\n\n/* ===== Responsive Design ===== */\n@media (max-width: 1024px) {\n  .posts-grid {\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .blog-title {\n    font-size: 2rem;\n  }\n\n  .blog-subtitle {\n    font-size: 1rem;\n  }\n\n  .category-filter {\n    gap: 0.5rem;\n  }\n\n  .category-btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.85rem;\n  }\n\n  .posts-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .gallery-grid.single .gallery-item {\n    height: 250px;\n  }\n\n  .gallery-grid.double .gallery-item {\n    height: 180px;\n  }\n\n  .gallery-grid.multiple {\n    grid-auto-rows: 130px;\n  }\n\n  .share-menu {\n    right: auto;\n    left: 0;\n  }\n\n  .modal-content {\n    padding: 2rem 1.5rem;\n  }\n\n  .modal-title {\n    font-size: 1.6rem;\n  }\n\n  .modal-gallery {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  }\n\n  .modal-image {\n    height: 150px;\n  }\n\n  .lightbox-prev,\n  .lightbox-next {\n    padding: 0.75rem;\n  }\n\n  .lightbox-close {\n    top: 1rem;\n    right: 1rem;\n  }\n\n  .post-video,\n  .modal-video {\n    max-height: 250px;\n  }\n}\n\n@media (max-width: 480px) {\n  .blog-container {\n    padding: 1rem;\n  }\n\n  .blog-header {\n    margin-bottom: 1.5rem;\n    padding: 1rem 0;\n  }\n\n  .blog-controls {\n    margin-bottom: 2rem;\n  }\n\n  .search-wrapper {\n    margin-bottom: 1.5rem;\n  }\n\n  .category-filter {\n    padding: 0;\n  }\n\n  .post-title {\n    font-size: 1.3rem;\n  }\n\n  .post-footer {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  }\n\n  .gallery-grid.single .gallery-item {\n    height: 200px;\n  }\n\n  .gallery-grid.double .gallery-item {\n    height: 150px;\n  }\n\n  .gallery-grid.multiple {\n    grid-auto-rows: 120px;\n  }\n\n  .modal-overlay {\n    padding: 1rem;\n  }\n\n  .modal-content {\n    padding: 1.5rem 1rem;\n    max-height: 95vh;\n  }\n\n  .modal-close {\n    width: 35px;\n    height: 35px;\n    top: 1rem;\n    right: 1rem;\n  }\n\n  .modal-title {\n    font-size: 1.4rem;\n    padding-right: 2.5rem;\n  }\n\n  .modal-gallery {\n    grid-template-columns: 1fr;\n  }\n\n  .load-more-btn {\n    padding: 0.9rem 2rem;\n    font-size: 0.95rem;\n  }\n}\n\n/* ===== Scrollbar Styling ===== */\n.modal-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.modal-content::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.modal-content::-webkit-scrollbar-thumb {\n  background: #00703C;\n  border-radius: 10px;\n}\n\n.modal-content::-webkit-scrollbar-thumb:hover {\n  background: #005a30;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
